import React, { useState, useEffect } from "react";
import {getContactInfo } from "../../services/routes.services";
const LocationCover = () => {
    const [contactList, setContactList] = useState([]);
    useEffect(() => {
        getContactInfo()
          .then((res) => {
            setContactList(res.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      }, []);
    return(
        <>
        <p>
             easyrecce is also live in <strong>{contactList.location_cover}</strong> more cities{" "}
        </p>
        </>
    )
}
export default LocationCover